import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { getParagraph14BoldTypography } from "../../Typography";
import Icon from "../Icon/Icon";

const StyledButton = styled.button<any>`
  padding: 0 16px;
  height: 40px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  box-sizing: border-box;
  border-radius: 6px;
  text-decoration: none;
  cursor: pointer;
  background: transparent;
  transition: background-color 200ms linear;

  &:hover {
    background: ${({ theme }) => theme.lightBackgroundColor};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    margin-bottom: 40px;
    width: 42px;
    height: 40px;
    padding: 0;
  }
`;

const ButtonContent = styled.div`
  margin: 0 auto;
  display: grid;
  grid-template-columns: auto auto;
  column-gap: 10px;
  justify-content: center;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    grid-template-columns: none;
    column-gap: 0;
    width: 0;
  }
`;

const ButtonLabel = styled.div`
  ${getParagraph14BoldTypography};
  line-height: 16px;
  color: ${({ theme }) => theme.primaryColor};
  white-space: nowrap;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    display: none;
  }
`;

interface IGoBackButton {
  style?: any;
  text?: string;
  onClick: () => void;
  className?: string;
}

const GoBackButton = ({ style, onClick, text, className }: IGoBackButton) => {
  const { t } = useTranslation();

  return (
    <StyledButton style={style} onClick={onClick} className={className}>
      <ButtonContent>
        <Icon name="backArrow" width="18px" height="12px" />
        <ButtonLabel>{text || t("requirements-go-back-button")}</ButtonLabel>
      </ButtonContent>
    </StyledButton>
  );
};

export default GoBackButton;
